import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["className"];
import React, { useMemo, useCallback } from 'react';
import { createUseStyles, TimePicker } from 'hoi-poi-ui';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from "./styles";
const useStyles = createUseStyles(styles, 'Time');
function timeToDate(time) {
  const [hours, minutes] = time.split(':').map(Number);
  const date = new Date();
  date.setHours(hours, minutes, 0, 0);
  return date;
}
function formatTime(date) {
  let hours = date.getHours();
  let minutes = date.getMinutes();
  hours = hours < 10 ? '0' + hours : hours;
  minutes = minutes < 10 ? '0' + minutes : minutes;
  return hours + ':' + minutes;
}
function Time(_ref) {
  let {
      className
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const classes = useStyles();
  const placeholders = 'hh:mm';
  const classNames = classnames(classes.root, className);
  const onChange = useCallback(newValue => {
    props.onChange(newValue ? formatTime(newValue) : newValue);
  }, [props]);
  const value = useMemo(() => props.value ? timeToDate(props.value) : props.value, [props.value]);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames
  }, /*#__PURE__*/React.createElement(TimePicker, _extends({
    labelMode: "horizontal",
    isFullWidth: true
  }, props, {
    value: value,
    onChange: onChange,
    placeholder: placeholders
  })));
}
process.env.NODE_ENV !== "production" ? Time.propTypes = {
  uiGrid: PropTypes.string
} : void 0;
export default /*#__PURE__*/React.memo(Time);